import { ITaskListItem } from "@/src/api/tasksPageRequests";
import { parseTaskNumericId } from "./parseTaskApplicantInfo";

export const taskIdMatchesSearch = (item: ITaskListItem, searchId: string): boolean => {
  const normalized = searchId.trim();
  if (!normalized) return false;

  const apiId = String(item.id).trim();
  if (apiId === normalized) return true;

  const searchNumeric = parseTaskNumericId(normalized);
  const itemNumeric = parseTaskNumericId(item.id);
  return searchNumeric > 0 && itemNumeric > 0 && searchNumeric === itemNumeric;
};

export const findTaskInList = (rows: ITaskListItem[], searchId: string): ITaskListItem | null =>
  rows.find((item) => taskIdMatchesSearch(item, searchId)) ?? null;
